export default __webpack_public_path__ + "static/media/UK.0d602dd1.gif";